// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Hl-z","tupacHeader":"Il-z","tupacHeader2":"Jl-z","tupacMenu":"Kl-z","tupacMenu2":"Ll-z","tupacMain":"Ml-z","tupacMain2":"Nl-z"};